import LoginScreen from '@/pages/login/login_screen';
import { useUserStore } from '@/state/user_state';
import TenantPageWrapper from './tenant_page_wrapper';
import { ReactNode } from 'react';

interface AuthPageWrapperProps {
    children: ReactNode;
}

export default function AuthPageWrapper({ children }: AuthPageWrapperProps) {
    const user = useUserStore((state) => state.user);

    if (!user) {
        return <LoginScreen />;
    }

    return (
        <TenantPageWrapper>
            {children}
        </TenantPageWrapper>
    );
}
